import { useQuery } from '@tanstack/react-query'
import { BookingChargeDetailsDto } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetBookingChargeDetails(bookingId: string): {
  chargeDetails: BookingChargeDetailsDto | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => void
} {
  const {
    data: chargeDetails,
    isLoading,
    isError,
    refetch,
  } = useQuery(
    GetBookingChargeDetailsQueryKey(bookingId),
    async () => {
      return qoursesApi.payment.paymentControllerGetBookingChargeDetailsV1(bookingId)
    },
    {
      enabled: !!bookingId,
    },
  )

  return { chargeDetails, isLoading, isError, refetch }
}

export const GetBookingChargeDetailsQueryKey = (bookingId: string) => [
  'booking',
  bookingId,
  'chargeDetails',
]
